/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'react',
	'mobx-react',
	'@ba/ba-ui-carbon-toolkit',
	'prop-types',
	'classnames',
], function(
	React,
	MobxReact,
	BA_UI_CARBON_TOOLKIT,
	PropTypes,
	cx
) {

	const BASE_CLASSNAME = 'properties--controls--FlyoutIconPicker';

	const { FlexLayout, FlexItem, IconPicker, Label } = BA_UI_CARBON_TOOLKIT;

	const getUISpec = (props) => {
		const { item } = props;
		let spec = item;
		if (item && item.editor && item.editor.uiControl) {
			spec = item.editor.uiControl;
		}
		return spec;
	};

	class FlyoutIconPicker extends React.Component {
		render() {
			const item = getUISpec(this.props);
			return (
				<FlexLayout
					className={cx(this.props.className, BASE_CLASSNAME)}
					data-property-id={item.id}
					direction="row"
					wrap="nowrap"
					justifyContent="space-between"
				>
					{this.renderLabel(item)}
					{this.renderControl(item)}
				</FlexLayout>
			);
		}

		renderLabel(item) {
			return (
				<FlexItem className={BASE_CLASSNAME + '--label'}>
					<Label label={item.label} />
				</FlexItem>
			);
		}

		renderControl({ items }) {
			const { setPropertyValue, value } = this.props.item;
			const icons = items.map(item => {
				return {
					icon: {
						id: item.value
					},
					iconId: item.name,
					label: item.label
				};
			});

			const selectedIcon = icons.find(item => item.icon.id === value) || icons[0];

			const isEmpty = selectedIcon.icon.id === 'none';

			return (
				<FlexItem className={BASE_CLASSNAME + '--control' + (isEmpty ? ' ' + BASE_CLASSNAME + '--control--empty' : '')}>
					<IconPicker
						orientation={'bottomRightStart'}
						icons={icons}
						selectedIcon={selectedIcon}
						onIconSelected={item => {
							setPropertyValue(item.icon.id);
						}}
					/>
				</FlexItem>
			);
		}
	}

	FlyoutIconPicker.propTypes = {
		item: PropTypes.shape({
			label: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			items: PropTypes.arrayOf(
				PropTypes.shape({
					name: PropTypes.string.isRequired,
					label: PropTypes.string.isRequired,
					value: PropTypes.string.isRequired
				})
			).isRequired,
			setPropertyValue: PropTypes.func.isRequired
		}),
		className: PropTypes.string,
	};
	FlyoutIconPicker.defaultProps = {};

	return MobxReact.observer(FlyoutIconPicker);
});